import { combineReducers } from 'redux';

import billingInfoReducer from './ducks/billing-info/reducers';
import invoiceReducer from './ducks/invoices/reducers';
import plansReducer from './ducks/plans/reducers';
import subscriptionsReducer from './ducks/subscriptions/reducers';
import purchaseReducer from './ducks/purchase/reducers';
import checkoutReducer from './ducks/checkout/reducers';

export default combineReducers({
  billingInfo: billingInfoReducer,
  checkout: checkoutReducer,
  invoices: invoiceReducer,
  plans: plansReducer,
  subscriptions: subscriptionsReducer,
  purchase: purchaseReducer,
});
